module.exports = "<div class=rbn-modal-title><%=STR.print_pwd%></div> <div class=rbn-code><%=pwd?pwd:\"...\"%></div> <div class=rbn-action> <div class=\"rbn-copy-code <%=pwd?\"\":\"rbn-disable\"%>\"><%=STR.print_copy_code%></div> <div class=\"rbn-next <%=pwd?\"\":\"rbn-disable\"%>\"><%=STR.print_next%></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/templates/print-password-template.html
// module id = 60
// module chunks = 0